import React from "react";

import CloseIcon from "@material-ui/icons/Close";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import { makeStyles, List, ListItem, IconButton, Box } from "@material-ui/core";

import { BuilderAppIconListItems } from "./BuilderAppIconListItems";
import { EventTracking } from "../../../../utilities/Tracking/EventTracking";
import { useBuilderDrawer } from "../../drawer/useBuilderDrawer";
import { useOfflineAssets } from '../../../offline/useOfflineAssets'

const useStyles = makeStyles((theme) => ({
    contentDrawer: {
        position: "relative",
        right: 0,
    },
    toolbar: theme.mixins.toolbar,
    chevron: {
        position: "fixed",
        bottom: 0,
        paddingLeft: 9,
        background: "white",
    },
}));

export function DesktopBuilderAppSelection() {
    const classes = useStyles();
    const builderDrawer = useBuilderDrawer();
    const {onlineMode} = useOfflineAssets();

	return (
		<div className={classes.contentDrawer}>
			<div className={classes.toolbar} />
            <List>
                <Box marginBottom="48px">
                    <BuilderAppIconListItems />
                </Box>
                <ListItem dense disableGutters className={classes.chevron}>
					<IconButton 
                    disabled={!onlineMode}
                    onClick={() => {
						builderDrawer.onMainDrawerChange(!builderDrawer.drawerOpen);
						EventTracking.Builder.onMainDrawerOpenWithChevron(`${builderDrawer.drawerOpen ? "Open" : "Close"} from  Arrow Icon`);
					}}>
                        {builderDrawer.drawerOpen ? <CloseIcon /> : <ChevronLeftIcon />}
                    </IconButton>
				</ListItem>
            </List>
		</div>
	);
}